module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BZTtNf/images/9781439657508.jpg?1684514557977",
      "alt": "This image is the cover for the book Bowie, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bowie, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Nestled in the heart of Prince George's County, the city of Bowie has grown from a Colonial farming area to become one of Maryland's largest cities. Its rich history is intertwined with those of the railroad, early tobacco culture, the rise of suburbia, and Thoroughbred racing. Belair Mansion and Stable bred some of the 20th century's most brilliant racers, including two Triple Crown winners raced under the Belair colors. The Belair Mansion and Stable remain today as two of Thoroughbred racing's most historic places. Built on the railroads, the city's birthplace was Huntington City. At the heart of Huntington was Bowie Station, named for Maryland governor Oden Bowie, an important figure in the presence of the railroad in the area. Today, the city of Bowie is a growing, vibrant, and diverse city, incorporating almost 400 years of history in its story. Bowie is a true American hometown where the present celebrates the past every day.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Pamela Peck Williams, Yoku Shaw-Taylor, \n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Pamela Peck Williams is a lifelong Maryland resident and manager of historic properties for the City of Bowie. The discovery and sharing of Bowie's history is the best part of her daily tasks. Yoku Shaw-Taylor has lived in Maryland for over 30 years and writes about the history of immigration.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0